<template>
    <div :class="classObj" class="app-wrapper">
        <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside"></div>
        <!-- 头部 -->
        <Header />
        <div class="main-container">
            <!-- 左边侧边栏 -->
            <Sidebar class="sidebar-container" />
            <app-main />
        </div>
        <!-- 底部tabbar -->
        <Tabbar />
        <MenuPop />
        <myProfilePopup></myProfilePopup>
        <myPopup></myPopup>
        <settingPopup></settingPopup>
        <betHistoryPopup></betHistoryPopup>
        <transactionPopup></transactionPopup>
        <bonusRainPopup></bonusRainPopup>
        <downAppPopup></downAppPopup>
        <checkInPop></checkInPop>
        <pendingPop></pendingPop>
        <turntablePopup></turntablePopup>
        <turntable2Popup></turntable2Popup>
        <lossSupportPopup></lossSupportPopup>
        <rebatePopup></rebatePopup>
        <winRankListPopup></winRankListPopup>
        <LotteryPopup></LotteryPopup>
        <treasureChestPopup></treasureChestPopup>
        <depositTotalPopup></depositTotalPopup>
        <depositRepeatPopup></depositRepeatPopup>
        <depositRepeatUsdtPopup></depositRepeatUsdtPopup>
        <partnerPopup></partnerPopup>
        <searchPopup></searchPopup>
        <playGameByDepositPopup></playGameByDepositPopup>
        <!-- <loginPopup></loginPopup> -->
    </div>
</template>

<script>
import AppMain from './components/AppMain.vue'
import Header from './components/Header.vue'
import Sidebar from './components/Sidebar.vue'
import Tabbar from './components/Tabbar.vue'
import ResizeMixin from './mixin/ResizeHandler'
import MenuPop from '@/views/home/modules/menuPop.vue'
import myProfilePopup from '@/components/myProfilePopup/index.vue'
import myPopup from '@/components/myPopup/index.vue'
import settingPopup from '@/components/settingPopup/index.vue'
import betHistoryPopup from '@/components/betHistory/index.vue'
import transactionPopup from '@/components/transactionPopup/index.vue'
import bonusRainPopup from '@/components/bonusRainPopup/index.vue'
import downAppPopup from '@/components/downAppPopup/index.vue'
import checkInPop from '@/components/checkInPopup/index.vue'
import pendingPop from '@/components/pendingPopup/index.vue'
import turntablePopup from '@/components/turntablePopup/index.vue'
import turntable2Popup from '@/components/turntable2Popup/index.vue'
import lossSupportPopup from '@/components/lossSupportPopup/index.vue'
import rebatePopup from '@/components/rebatePopup/index.vue'
import winRankListPopup from '@/components/winRankListPopup'
import LotteryPopup from '@/components/LotteryPopup'
import treasureChestPopup from '@/components/treasureChestPopup'
import depositTotalPopup from '@/components/depositTotalPopup'
import depositRepeatPopup from '@/components/depositRepeatPopup'
import depositRepeatUsdtPopup from '@/components/depositRepeatUsdtPopup'
import playGameByDepositPopup from '@/components/playGameByDepositPopup'
import partnerPopup from '@/components/partnerPopup'
import searchPopup from '@/components/searchPopup'
import { mapState } from 'vuex'
export default {
    name: 'Layout',
    components: { AppMain, Sidebar, Header, Tabbar, myProfilePopup, myPopup, settingPopup, betHistoryPopup, transactionPopup, bonusRainPopup, downAppPopup, checkInPop, pendingPop, turntablePopup, turntable2Popup, lossSupportPopup, winRankListPopup, rebatePopup, LotteryPopup, treasureChestPopup, depositTotalPopup, depositRepeatPopup, depositRepeatUsdtPopup, partnerPopup, searchPopup, MenuPop, playGameByDepositPopup },
    mixins: [ResizeMixin],
    computed: {
        ...mapState({
            sidebar: state => state.app.sidebar,
            device: state => state.app.device
        }),
        classObj() {
            const obj = {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
                withoutAnimation: this.sidebar.withoutAnimation,
                mobile: this.device === 'mobile',
                hideMenuPop: !this.showMenuPop
            }
            const meta = this.$route.meta
            if (meta) {
                const isMobileOnlyCustomer = meta.isMobileOnlyCustomer
                const isMobileHideHeader = meta.isMobileHideHeader
                const isMobileHideFooter = meta.isMobileHideFooter
                const isMobileHideTabbar = meta.isMobileHideTabbar
                const isAppW100P = meta.isAppW100P
                obj.isMobileOnlyCustomer = isMobileOnlyCustomer
                obj.isMobileHideHeader = isMobileHideHeader
                obj.isMobileHideFooter = isMobileHideFooter
                obj.isMobileHideTabbar = isMobileHideTabbar
                obj.isAppW100P = isAppW100P
            }
            return obj
        },
        showMenuPop() {
            if (this.device === 'mobile') {
                if (this.$route.path.indexOf('/Home') !== -1) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        }
    },
    methods: {
        handleClickOutside() {
            this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/common/styles/viriables.scss';

.app-wrapper {
    position: relative;
    height: 100vh;
    width: 100%;
    background-image: var(--theme-page-bg);
    background-size: var(--theme-page-bg-size);
    background-position: var(--theme-page-bg-position);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    z-index: 1;

    &::before {
        content: "";
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: -1;
        opacity: .6;
        box-shadow: 0 0 100px .5rem rgba($bg-shell-color, .78) inset;
    }

    &::after {
        content: "";
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        right: 0;
        z-index: -2;
        opacity: .18;
        background-image: var(--theme-page-bg);
        background-size: var(--theme-page-bg-size);
        background-position: var(--theme-page-bg-position);
    }

    &.mobile.openSidebar {
        position: fixed;
        top: 0;
    }

    &.hideMenuPop {
        ::v-deep .fold_icon {
            &.menus {
                display: none;
            }
        }

        ::v-deep .ant-dropdown {
            display: none;
        }
    }

    .main-container {
        flex: 1;
        width: 100%;
        height: 100%;
        position: relative;
        background-image: var(--theme-page-bg);
        background-size: var(--theme-page-bg-size);
        background-position: var(--theme-page-bg-position);
    }

    .sidebar-container {
        position: fixed;
        top: 1.2rem;
        bottom: 0;
        left: 0;
        z-index: 1087;
    }

    &.isAppW100P {
        ::v-deep .app-main {
            .app-main-wrap {
                max-width: 100% !important;
                width: 100% !important;
            }
        }
    }

    &.hideSidebar {
        .sidebar-container {
            width: 0 !important;

            ::v-deep .Opend {
                pointer-events: none;
                transform: translate3d(-100%, 0, 0);
            }

            ::v-deep .PC-hide {
                transition-delay: .3s;
                transition-duration: .3s;
                pointer-events: auto;
            }

            ::v-deep .Sidebar-close-icon {
                display: none;
            }
        }

        ::v-deep .app-main {
            left: 0 !important;
        }

        ::v-deep .pages-header {
            padding-left: 0 !important;
        }
    }

    &.mobile {
        .sidebar-container {
            width: 5.8rem !important;
            top: 0;

            ::v-deep .Opend {
                transition: transform .28s;
                width: 100% !important;
                // padding: .5rem .2rem .3rem;
            }

            ::v-deep .Sidebar-close-icon {
                display: flex !important;
            }

            ::v-deep .menu-item {
                height: .94rem;
                font-size: .3rem;
                margin-bottom: .18rem;

                .icon_hot {
                    width: .68rem;
                    height: .68rem;
                    right: .28rem;
                }

                .upto-rate-wrap {
                    top: calc(50% - .3rem);
                    right: 0;
                    width: 1.5rem;
                    height: .6rem;
                    font-size: .24rem;
                }

                &.act,
                &:hover {
                    &::before{
                        height: .94rem;
                    }
                }
            }
        }

        &.hideSidebar {
            .sidebar-container {
                pointer-events: none;
                transform: translate3d(-100%, 0, 0);
            }

            ::v-deep .Sidebar-close-icon {
                display: none !important;
            }
        }

        ::v-deep .app-main {
            left: 0 !important;
            right: 0 !important;

            .app-main-wrap {
                min-width: 100% !important;
                padding: 0 !important;
            }
        }

        ::v-deep .pages-header {
            padding-left: 0 !important;
            padding-right: .18rem;
            height: 1rem;

            .user_action {
                min-width: 100% !important;
                padding: 0 !important;

                .person {
                    display: none;
                }
            }

            .Notification {
                position: relative;
                margin-left: .1rem;
                width: .65rem;
                height: .65rem;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #29093E;
                border-radius: .14rem;
            }
        }

        ::v-deep .footer {
            padding: .32rem .2rem !important;
            padding-bottom: .38rem !important;

            .desc-logos {
                gap: .18rem;
                padding-top: 0;

                & > img {
                    height: .38rem;
                    margin-bottom: 0;
                }
            }
        }

        ::v-deep .classify {
            display: block !important;
            min-width: 100% !important;
            padding: 0 !important;
            margin-top: .2rem;

            .classify-sub {
                width: 100% !important;
                padding-right: 0 !important;
                background: var(--theme-footer-menu-title-bg);
                margin-bottom: .2rem;
                & > .icon-18{
                    display: none;
                }

                &.act {
                    .classify-sub-title {
                        color: var(--theme-bright-text);

                        &.arrow {
                            &::after {
                                border-color: var(--theme-bright-text);
                                top: .36rem;
                                transform: rotate(-45deg);
                            }
                        }
                    }

                    .classify-sub-list {
                        display: flex;
                    }
                }

                .classify-sub-title {
                    text-transform: none;
                    color: var(--theme-footer-title-text);
                    width: 100%;
                    padding: .2rem .28rem;
                    margin: 0;
                    position: relative;
                    font-size: .24rem;

                    &.arrow {
                        &::after {
                            content: "";
                            position: absolute;
                            width: 10px;
                            height: 10px;
                            border-radius: 1px;
                            border-top: 2px solid;
                            border-right: 2px solid;
                            border-color: var(--theme-footer-title-text);
                            right: .28rem;
                            top: .28rem;
                            transform: rotate(135deg);
                            transition-duration: 0.3s;
                        }
                    }
                }

                .classify-sub-list {
                    display: none;
                    padding: .1rem .28rem;
                    background: var(--theme-footer-menu-list-bg);

                    .classify-sub-item {
                        padding: 0;
                        font-size: .24rem;
                        color: var(--theme-footer-menu-link-text);
                        line-height: .52rem;
                        margin: 0;
                        margin-right: .3rem;
                        text-decoration-line: underline;

                        &:hover,
                        &.act {
                            color: var(--theme-bright-text);
                        }
                    }
                }
            }
        }

        ::v-deep .desc {
            display: block;
            width: 100%;
            min-width: 100% !important;
            margin-top: .3rem;
            // padding: .2rem;

            .desc-content {
                font-size: .22rem;
                position: relative;
                padding-right: 1rem;

                .icon-18{
                    display: block;
                    width: .68rem;
                    height: .68rem;
                    vertical-align: middle;
                    position: absolute;
                    top: .2rem;
                    right: .24rem;
                }
            }
            .logo {
                height: .88rem;
                margin-bottom: .2rem;
            }
        }
        ::v-deep .copyright {
            font-size: .18rem;
        }

        ::v-deep .tabbar {
            display: flex !important;
            max-width: 100% !important;
        }

        ::v-deep .tabbar-content {
            display: block !important;
            max-width: 100% !important;
        }
    }

    &.withoutAnimation {
        .main-container,
        .sidebar-container {
            transition: none;
        }
    }

    &.mobile {
        &.isMobileHideFooter {
            ::v-deep .footer {
                display: none;
            }
        }

        &.isMobileOnlyCustomer {
            ::v-deep .footer {
                .classify {
                    .classify-sub {
                        &.hide {
                            display: none !important;
                        }
                    }
                }

                .desc {
                    display: none !important;
                }
            }
        }

        &.isMobileHideHeader {
            ::v-deep .fixed-header {
                display: none;
            }
        }

        &.isMobileHideTabbar {
            ::v-deep .tabbar-content {
                display: none !important;
            }
        }
    }
}

.drawer-bg {
    background: var(--theme-sidebar-drawer-mask-bg);
    opacity: 1;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 1086;
}
</style>
